import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_6727_44172)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_6727_44172"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "20",
  height: "20",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 20 20",
    fill: "none"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M15.4756 16.6654C16.5273 16.6654 17.3806 15.8129 17.3806 14.7604V10.9512L18.3331 9.9987L17.3806 9.0462V5.23703C17.3806 4.18453 16.5281 3.33203 15.4756 3.33203M4.52413 3.33203C3.47163 3.33203 2.61913 4.18453 2.61913 5.23703V9.0462L1.66663 9.9987L2.61913 10.9512V14.7604C2.61913 15.8129 3.47163 16.6654 4.52413 16.6654M9.99996 6.66536V13.332M6.66663 9.9987H13.3333",
    stroke: $props.color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3)]), _hoisted_4], 8, _hoisted_1);
}